import { gamesMessagesEntity } from '@bg-shared/business/GamesMessages';
import { GameMessagePlacement } from '@bg-shared/business/GamesMessages/enums';
import { t } from '@bg-shared/business/Translate';
import { SHOW_NOTIFICATION_TIME } from '@bg-shared/constants/constants';
import { casinoAutoPlayEntity } from '../store';

class CasinoAutoPlayService {
    public stopAutoPlay(
        casinoAutoPlayStore: ReturnType<typeof casinoAutoPlayEntity.store>,
        message = 'auto_play_stop',
    ): void {
        if (!casinoAutoPlayStore.value.isActive) {
            return;
        }

        casinoAutoPlayStore.clearAutoPlay();

        gamesMessagesEntity.addToQueue(
            {
                message: t.string(message),
                timeout: SHOW_NOTIFICATION_TIME,
            },
            GameMessagePlacement.TOP,
        );
    }
}

export const casinoAutoPlayService = new CasinoAutoPlayService();
